export const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const MST = "MST";
const MDT = "MDT";
const CDT = "CDT";
const CST = "CST";
const PST = "PST";
const PDT = "PDT";

const EST = "EST";
const EDT = "EDT";

const HST = "HST";
const HDT = "HDT";

export const getFormattedTimezone = (): string => {
  const now = new Date();
  const offsetMinutes = now.getTimezoneOffset();
  const offsetHours = -offsetMinutes / 60;

  const offsetKey = offsetHours.toString();

  const offset = getTimezoneWithZone(offsetKey, timezone);

  return offset;
};

const getTimezoneWithZone = (offset: string, timezone: string): string => {
  switch (timezone) {
    case "America/Chicago":
    case "America/Indiana/Knox":
    case "America/Menominee":
    case "America/North_Dakota/Beulah":
    case "America/North_Dakota/Center":
    case "America/North_Dakota/New_Salem":
      return offset === "-5" ? CDT : CST;

    case "America/Denver":
    case "America/Boise":
    case "America/Phoenix":
      return offset === "-6" ? MDT : MST;

    case "America/Los_Angeles":
      return offset === "-7" ? PDT : PST;

    case "America/New_York":
    case "America/Detroit":
    case "America/Indiana/Indianapolis":
    case "America/Indiana/Marengo":
    case "America/Indiana/Vincennes":
    case "America/Indiana/Winamac":
    case "America/Indiana/Vevay":
    case "America/Kentucky/Louisville":
    case "America/Kentucky/Monticello":
      return offset === "-4" ? EDT : EST;

    case "America/Adak":
    case "Pacific/Honolulu":
      return offset === "-9" ? HDT : HST;

    default:
      return timezone;
  }
};
